export default "__VITE_ASSET__0ced684a__"